const PROMOTE_CODE_STORAGE_KEY = "promoteCode";

export const usePromoteCode = () => {
  const getQueryValue = value => {
    return Array.isArray(value) ? value[0] || "" : value || "";
  };

  const savePromoteCode = value => {
    const promoteCode = getQueryValue(value);
    if (!promoteCode || !process.client) {
      return promoteCode;
    }

    localStorage.setItem(PROMOTE_CODE_STORAGE_KEY, promoteCode);
    return promoteCode;
  };

  const getCachedPromoteCode = () => {
    if (!process.client) {
      return "";
    }

    return localStorage.getItem(PROMOTE_CODE_STORAGE_KEY) || "";
  };

  const getStoredPromoteCode = value => {
    const promoteCode = getQueryValue(value);
    return promoteCode || getCachedPromoteCode();
  };

  return {
    getQueryValue,
    savePromoteCode,
    getCachedPromoteCode,
    getStoredPromoteCode
  };
};
